var map = {
	"./404-bg": 209,
	"./404-bg.png": 209,
	"./404-img-1": 210,
	"./404-img-1.png": 210,
	"./404-img-2": 211,
	"./404-img-2.png": 211,
	"./404-img-3": 212,
	"./404-img-3.png": 212,
	"./banner": 213,
	"./banner-bg": 214,
	"./banner-bg.jpg": 214,
	"./banner.svg": 213,
	"./bg-finger-print": 215,
	"./bg-finger-print.png": 215,
	"./business-modelling/welcome": 126,
	"./business-modelling/welcome.jpg": 126,
	"./business-modelling/welcome@2x": 135,
	"./business-modelling/welcome@2x.jpg": 135,
	"./checkbox": 216,
	"./checkbox-green": 217,
	"./checkbox-green.svg": 217,
	"./checkbox-white": 218,
	"./checkbox-white.svg": 218,
	"./checkbox.svg": 216,
	"./checkmark": 219,
	"./checkmark.svg": 219,
	"./contact-img": 220,
	"./contact-img.jpg": 220,
	"./cost-recovery-bg": 221,
	"./cost-recovery-bg.png": 221,
	"./cost-to-serve-bg": 222,
	"./cost-to-serve-bg.png": 222,
	"./decision-maker-bg": 110,
	"./decision-maker-bg.png": 110,
	"./decision-maker-bg.webp": 595,
	"./disclaimer-bg": 223,
	"./disclaimer-bg.jpg": 223,
	"./feedback-bg": 224,
	"./feedback-bg.png": 224,
	"./fields": 225,
	"./fields.jpeg": 225,
	"./finger-print": 226,
	"./finger-print-green": 227,
	"./finger-print-green.png": 227,
	"./finger-print.png": 226,
	"./footer-logo": 228,
	"./footer-logo.svg": 228,
	"./guides-test-img": 229,
	"./guides-test-img.png": 229,
	"./guides-widget-bg": 230,
	"./guides-widget-bg.png": 230,
	"./icons/1-green": 231,
	"./icons/1-green.svg": 231,
	"./icons/1-white": 232,
	"./icons/1-white.svg": 232,
	"./icons/2-green": 233,
	"./icons/2-green.svg": 233,
	"./icons/2-white": 234,
	"./icons/2-white.svg": 234,
	"./icons/3-green": 235,
	"./icons/3-green.svg": 235,
	"./icons/add-circle-blue": 120,
	"./icons/add-circle-blue.svg": 120,
	"./icons/arrow-down": 236,
	"./icons/arrow-down-green": 237,
	"./icons/arrow-down-green.svg": 237,
	"./icons/arrow-down.svg": 236,
	"./icons/arrow-left": 238,
	"./icons/arrow-left-black": 116,
	"./icons/arrow-left-black.png": 116,
	"./icons/arrow-left.svg": 238,
	"./icons/arrow-lookup": 136,
	"./icons/arrow-lookup.svg": 136,
	"./icons/arrow-right-blue": 239,
	"./icons/arrow-right-blue.svg": 239,
	"./icons/arrow-up": 240,
	"./icons/arrow-up.svg": 240,
	"./icons/beans": 241,
	"./icons/beans.svg": 241,
	"./icons/bm": 242,
	"./icons/bm.svg": 242,
	"./icons/building": 243,
	"./icons/building.svg": 243,
	"./icons/bullet": 244,
	"./icons/bullet.svg": 244,
	"./icons/button-arrow": 245,
	"./icons/button-arrow.svg": 245,
	"./icons/chart-blue": 137,
	"./icons/chart-blue.svg": 137,
	"./icons/chart-gray": 138,
	"./icons/chart-gray.png": 138,
	"./icons/check-circle-white": 139,
	"./icons/check-circle-white.png": 139,
	"./icons/close": 140,
	"./icons/close-circle-blue": 141,
	"./icons/close-circle-blue.svg": 141,
	"./icons/close-dark": 127,
	"./icons/close-dark.png": 127,
	"./icons/close-green": 246,
	"./icons/close-green.svg": 246,
	"./icons/close.png": 140,
	"./icons/computer": 142,
	"./icons/computer.png": 142,
	"./icons/confidence-level-1": 247,
	"./icons/confidence-level-1.svg": 247,
	"./icons/confidence-level-2": 248,
	"./icons/confidence-level-2.svg": 248,
	"./icons/confidence-level-3": 249,
	"./icons/confidence-level-3.svg": 249,
	"./icons/confidence-level-4": 250,
	"./icons/confidence-level-4.svg": 250,
	"./icons/confidence-level-5": 251,
	"./icons/confidence-level-5.svg": 251,
	"./icons/data-explorer": 252,
	"./icons/data-explorer.svg": 252,
	"./icons/download": 253,
	"./icons/download-file": 254,
	"./icons/download-file-green": 255,
	"./icons/download-file-green.svg": 255,
	"./icons/download-file.svg": 254,
	"./icons/download-page": 256,
	"./icons/download-page.svg": 256,
	"./icons/download.svg": 253,
	"./icons/editor-link": 257,
	"./icons/editor-link.svg": 257,
	"./icons/editor-unlink": 258,
	"./icons/editor-unlink.svg": 258,
	"./icons/email": 259,
	"./icons/email-outline": 260,
	"./icons/email-outline.svg": 260,
	"./icons/email.svg": 259,
	"./icons/facebook": 261,
	"./icons/facebook.svg": 261,
	"./icons/france": 262,
	"./icons/france.svg": 262,
	"./icons/glossary-icon": 263,
	"./icons/glossary-icon.svg": 263,
	"./icons/green-arrow-left": 264,
	"./icons/green-arrow-left.svg": 264,
	"./icons/green-arrow-right": 265,
	"./icons/green-arrow-right.svg": 265,
	"./icons/green-finger-print": 266,
	"./icons/green-finger-print.svg": 266,
	"./icons/help": 118,
	"./icons/help.png": 118,
	"./icons/home": 267,
	"./icons/home.svg": 267,
	"./icons/icon-blended-finance": 268,
	"./icons/icon-blended-finance.svg": 268,
	"./icons/icon-building": 269,
	"./icons/icon-building.svg": 269,
	"./icons/icon-bulb": 270,
	"./icons/icon-bulb.svg": 270,
	"./icons/icon-business-practices": 271,
	"./icons/icon-business-practices.svg": 271,
	"./icons/icon-buyer": 272,
	"./icons/icon-buyer.svg": 272,
	"./icons/icon-checkmark": 273,
	"./icons/icon-checkmark.svg": 273,
	"./icons/icon-farmer": 274,
	"./icons/icon-farmer.svg": 274,
	"./icons/icon-fertilizer": 275,
	"./icons/icon-fertilizer.svg": 275,
	"./icons/icon-heart": 276,
	"./icons/icon-heart.svg": 276,
	"./icons/icon-location-2": 277,
	"./icons/icon-location-2.svg": 277,
	"./icons/icon-monitoring": 278,
	"./icons/icon-monitoring.svg": 278,
	"./icons/icon-progress": 279,
	"./icons/icon-progress.svg": 279,
	"./icons/icon-replanting": 280,
	"./icons/icon-replanting.svg": 280,
	"./icons/icon-reporting": 281,
	"./icons/icon-reporting.svg": 281,
	"./icons/icon-retail": 282,
	"./icons/icon-retail.svg": 282,
	"./icons/icon-tools": 283,
	"./icons/icon-tools.svg": 283,
	"./icons/icon-warning": 284,
	"./icons/icon-warning.svg": 284,
	"./icons/idc": 285,
	"./icons/idc.svg": 285,
	"./icons/innovations/business": 286,
	"./icons/innovations/business.svg": 286,
	"./icons/innovations/cost": 287,
	"./icons/innovations/cost-o30": 288,
	"./icons/innovations/cost-o30.svg": 288,
	"./icons/innovations/cost.svg": 287,
	"./icons/innovations/farmer": 289,
	"./icons/innovations/farmer.svg": 289,
	"./icons/innovations/feedback": 290,
	"./icons/innovations/feedback.svg": 290,
	"./icons/innovations/level-green-high": 291,
	"./icons/innovations/level-green-high.svg": 291,
	"./icons/innovations/level-green-low": 292,
	"./icons/innovations/level-green-low.svg": 292,
	"./icons/innovations/level-green-medium": 293,
	"./icons/innovations/level-green-medium.svg": 293,
	"./icons/innovations/level-high": 294,
	"./icons/innovations/level-high.svg": 294,
	"./icons/innovations/level-low": 295,
	"./icons/innovations/level-low.svg": 295,
	"./icons/innovations/level-medium": 296,
	"./icons/innovations/level-medium.svg": 296,
	"./icons/innovations/time": 297,
	"./icons/innovations/time-faded": 298,
	"./icons/innovations/time-faded.svg": 298,
	"./icons/innovations/time.svg": 297,
	"./icons/insights-explorer": 299,
	"./icons/insights-explorer.svg": 299,
	"./icons/instagram": 300,
	"./icons/instagram.svg": 300,
	"./icons/link": 128,
	"./icons/link-white": 143,
	"./icons/link-white.svg": 143,
	"./icons/link.svg": 128,
	"./icons/linkedin": 301,
	"./icons/linkedin.svg": 301,
	"./icons/location": 302,
	"./icons/location.svg": 302,
	"./icons/logo": 303,
	"./icons/logo-green": 144,
	"./icons/logo-green.png": 144,
	"./icons/logo.png": 303,
	"./icons/n-a": 111,
	"./icons/n-a.png": 111,
	"./icons/n-a.svg": 596,
	"./icons/pdf": 129,
	"./icons/pdf-white": 130,
	"./icons/pdf-white.svg": 130,
	"./icons/pdf.svg": 129,
	"./icons/picker-shape": 304,
	"./icons/picker-shape.svg": 304,
	"./icons/play-button": 305,
	"./icons/play-button-large": 306,
	"./icons/play-button-large.svg": 306,
	"./icons/play-button.svg": 305,
	"./icons/positive-trend": 307,
	"./icons/positive-trend.svg": 307,
	"./icons/print": 308,
	"./icons/print-white": 309,
	"./icons/print-white.svg": 309,
	"./icons/print.svg": 308,
	"./icons/quote": 310,
	"./icons/quote-large": 311,
	"./icons/quote-large.svg": 311,
	"./icons/quote.svg": 310,
	"./icons/search": 312,
	"./icons/search.svg": 312,
	"./icons/share": 313,
	"./icons/share.svg": 313,
	"./icons/sidebar-step": 314,
	"./icons/sidebar-step.svg": 314,
	"./icons/simple-arrow-down": 315,
	"./icons/simple-arrow-down.svg": 315,
	"./icons/soundcloud": 316,
	"./icons/soundcloud.svg": 316,
	"./icons/spain": 317,
	"./icons/spain.svg": 317,
	"./icons/strong-relationship": 318,
	"./icons/strong-relationship.svg": 318,
	"./icons/test-pic": 319,
	"./icons/test-pic.svg": 319,
	"./icons/trending": 320,
	"./icons/trending.svg": 320,
	"./icons/twitter": 321,
	"./icons/twitter.svg": 321,
	"./icons/united-kingdom": 322,
	"./icons/united-kingdom.svg": 322,
	"./icons/weak-relationship": 323,
	"./icons/weak-relationship.svg": 323,
	"./icons/white-arrow-right": 324,
	"./icons/white-arrow-right.svg": 324,
	"./icons/white-bullet": 325,
	"./icons/white-bullet.svg": 325,
	"./icons/wiki-crumbs-arrow": 326,
	"./icons/wiki-crumbs-arrow.svg": 326,
	"./icons/wiki-search": 327,
	"./icons/wiki-search.svg": 327,
	"./icons/wiki-third-level-branch": 328,
	"./icons/wiki-third-level-branch-last": 329,
	"./icons/wiki-third-level-branch-last.svg": 329,
	"./icons/wiki-third-level-branch.svg": 328,
	"./icons/youtube": 330,
	"./icons/youtube.svg": 330,
	"./insights-img": 331,
	"./insights-img.png": 331,
	"./logo": 332,
	"./logo-green": 333,
	"./logo-green.svg": 333,
	"./logo.svg": 332,
	"./n-a": 334,
	"./n-a.jpg": 334,
	"./new_logo": 335,
	"./new_logo.svg": 335,
	"./newsletter-bg": 336,
	"./newsletter-bg.jpg": 336,
	"./page-content-bg": 337,
	"./page-content-bg.jpg": 337,
	"./paradigm-bg": 112,
	"./paradigm-bg.jpg": 112,
	"./paradigm-bg.webp": 597,
	"./placeholder": 145,
	"./placeholder.png": 145,
	"./playbook-blue-card-bg": 338,
	"./playbook-blue-card-bg.png": 338,
	"./playbook-green-card-bg": 339,
	"./playbook-green-card-bg.png": 339,
	"./playbook-hero-bg": 113,
	"./playbook-hero-bg.jpg": 113,
	"./playbook-hero-bg.webp": 598,
	"./playbook-yellow-card-bg": 340,
	"./playbook-yellow-card-bg.png": 340,
	"./practitioner-bg": 114,
	"./practitioner-bg.png": 114,
	"./practitioner-bg.webp": 599,
	"./research-analyst-bg": 115,
	"./research-analyst-bg.png": 115,
	"./research-analyst-bg.webp": 600,
	"./subscribe-pg": 341,
	"./subscribe-pg.png": 341,
	"./test-pic": 342,
	"./test-pic.png": 342,
	"./value-created-bg": 343,
	"./value-created-bg.png": 343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;